/**
 * French messages for the API's account-level `security.error.*` keys
 * (SFAPI-180). The API sends the key either as `message` (401 from a revoked
 * session, `/api/auth_code`, `/login_link`) or inside a 422 login violation
 * `detail` prefixed with the property path (`emailOrPhone: security.error.…`).
 */
export const SECURITY_ERROR_MESSAGES: Record<string, string> = {
  "security.error.user_inactive":
    "Votre compte a été désactivé. Contactez le responsable de votre restaurant.",
  "security.error.employee_without_restaurant":
    "Votre compte n'est plus rattaché à aucun restaurant.",
  "security.error.manager_without_restaurant":
    "Votre compte n'est plus rattaché à aucun restaurant.",
  "security.error.owner_without_franchise":
    "Votre compte n'est plus rattaché à aucune franchise.",
};

export const getSecurityErrorMessage = (
  code: string | null | undefined
): string | undefined => {
  if (!code) return undefined;
  const key = code.replace(/^\w+: /, "");

  return SECURITY_ERROR_MESSAGES[key];
};
